/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface ServiceSubmission
 */
export interface ServiceSubmission {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceSubmission
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ServiceSubmission
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    serviceForm: string;
    /**
     * All vaccine form ids covered by this single-visit submission
     * @type {Array<string>}
     * @memberof ServiceSubmission
     */
    vaccineIds?: Array<string>;
    /**
     * Snapshot of the vaccine names covered by this submission
     * @type {Array<string>}
     * @memberof ServiceSubmission
     */
    vaccineNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    formName: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    formCategory: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    patientName: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    patientEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    patientPhone?: string;
    /**
     * Submitted answers keyed by field key
     * @type {any}
     * @memberof ServiceSubmission
     */
    formData: any;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    status: ServiceSubmissionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    adminNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceSubmission
     */
    appointment?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ServiceSubmissionStatusEnum {
    Pending = 'Pending',
    Confirmed = 'Confirmed',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}

